module.exports = __webpack_public_path__ + "static/img/mjfServer1.48a6334.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mjfServer1.png
// module id = slOL
// module chunks = 2